import { useEffect } from 'react';
import { trackEvent } from '@/lib/analytics';

const STORAGE_KEY = 'molish-lifecycle-attribution';
const ALLOWED_CAMPAIGNS = new Set(['welcome', 'abandoned_wizard']);

/**
 * Fires `lifecycle_email_click` in Firebase Analytics when the dashboard loads
 * with `?utm_source=lifecycle` — the UTM tag we put on welcome and
 * abandoned-wizard email CTAs. Deduped per session via sessionStorage so a
 * page reload during the same visit doesn't double-count.
 *
 * Mounted near the root so it runs once on first render regardless of route.
 */
export function LifecycleEmailAttribution() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('utm_source') !== 'lifecycle') return;

    let alreadyFired = false;
    try {
      alreadyFired = window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      // sessionStorage can be blocked (private mode, iframes) — fire anyway.
    }
    if (alreadyFired) return;

    const campaignRaw = params.get('utm_campaign') ?? 'unknown';
    const campaign = ALLOWED_CAMPAIGNS.has(campaignRaw) ? campaignRaw : 'unknown';
    const medium = params.get('utm_medium') ?? 'email';

    trackEvent('lifecycle_email_click', {
      campaign,
      medium,
      landing_path: window.location.pathname,
    });

    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore
    }
  }, []);

  return null;
}
